import { useRecoilCallback } from "recoil";
import { removeUserSim, UserSimRemoveRequest } from "api/userSimApi";
import { getPatientIdFromTaskKey } from "logic/logics";
import { userAtom } from "recoil/userAtom";
import { captureException } from "utils/sentry";

const RETRY_DELAY_MS = 1000;

// 실패하면 한 번만 다시 보낸다 (이미 없는 기록이어도 Agent 는 200)
const removeWithRetry = (req: UserSimRemoveRequest) =>
  removeUserSim(req).catch(() =>
    new Promise<void>((resolve) => setTimeout(resolve, RETRY_DELAY_MS)).then(
      () => removeUserSim(req)
    )
  );

// 교육용 모의 내담자가 생각기록지를 지우면 user_sim Agent 에 알린다 — 지운 사건이 다음 생성에 쓰이지 않도록 (계약 5.1).
// 보낼 때만 Promise 를 돌려준다 (실패해도 resolve). 그 밖의 사용자는 undefined.
export default function useUserSimRemove(taskKey: string) {
  return useRecoilCallback(
    ({ snapshot }) =>
      (recordKey: string): Promise<void> | undefined => {
        if (!snapshot.getLoadable(userAtom).getValue()?.isSimulated) {
          return undefined;
        }
        // patient_id 는 마치기 알림(task.patient_id)과 같게 활동지 키에서
        const patientId = getPatientIdFromTaskKey(taskKey);
        return removeWithRetry({
          patient_id: Number.isNaN(patientId) ? null : patientId,
          record_key: recordKey,
        }).catch((error) =>
          captureException(error, {
            tags: { action: "user_sim_remove" },
            extra: { taskKey, recordKey },
          })
        );
      },
    [taskKey]
  );
}
